import { useState } from 'react'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import Select from 'react-select'
import {
  PRODUCT_CATEGORY,
  PRODUCT_DETAIL_FIELDS,
  PRODUCT_ORIGIN,
} from '../../common/constant/page-constant'
import AttachIcon from '../../assets/AttachIcon'
import CloseIcon from '../../assets/CloseIcon'
import CheckIcon from '../../assets/CheckIcon'
import './ManageProduct.scss'

const ManageProductForm = ({
  open,
  handleDrawerToggle,
  serverError,
  newProductData,
  handleProductDetailsUpdate,
  isFieldErrorVisible,
  medicalCategoryList,
  handleSubmit,
  supplierList,
  props,
}) => {
  const [openPreview, setOpenPreview] = useState(false)

  const productImage = newProductData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_IMAGE]

  let previewImageSrc = null

  if (productImage?.url) {
    previewImageSrc = productImage.url
  } else if (productImage instanceof File) {
    previewImageSrc = URL.createObjectURL(productImage)
  } else {
    previewImageSrc = null
  }

  return (
    <>
      <SideDrawer
        handleDrawerToggle={handleDrawerToggle}
        open={open}
        drawerButton={true}
        drawerHeading="Add Product"
        buttonText={'Save'}
        handleClick={() => handleSubmit()}
      >
        <div className="wizardFieldset">
          {serverError && <div class="invalidFeedback mb-4">{serverError}</div>}
          <div className="formGroup formFloating fgrow1">
            <input
              type="text"
              className="formControl"
              id="genericName"
              placeholder="Product Name"
              value={newProductData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_NAME] || ''}
              onChange={(e) =>
                handleProductDetailsUpdate(
                  PRODUCT_DETAIL_FIELDS.PRODUCT_NAME,
                  e.target.value
                )
              }
              required
            />
            <label htmlFor="bonusquantity">Product Name</label>
            {isFieldErrorVisible &&
              !newProductData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_NAME] && (
                <div class="invalidFeedback">
                  Please select a valid Product Name.
                </div>
              )}
          </div>
          <div className="formGroup formFloating fgrow1">
            <input
              type="text"
              className="formControl"
              id="genericName"
              placeholder="Size"
              value={newProductData?.[PRODUCT_DETAIL_FIELDS.DOSE] || ''}
              onChange={(e) =>
                handleProductDetailsUpdate(
                  PRODUCT_DETAIL_FIELDS.DOSE,
                  e.target.value
                )
              }
              required
            />
            <label htmlFor="bonusquantity">Size</label>
            {isFieldErrorVisible &&
              !newProductData?.[PRODUCT_DETAIL_FIELDS.DOSE] && (
                <div class="invalidFeedback">Please enter a valid Size.</div>
              )}
          </div>
          <div className="formGroup formFloating fgrow1">
            <input
              type="text"
              className="formControl"
              id="genericName"
              placeholder="Generic Name"
              value={newProductData?.[PRODUCT_DETAIL_FIELDS.GENERIC_NAME] || ''}
              onChange={(e) =>
                handleProductDetailsUpdate(
                  PRODUCT_DETAIL_FIELDS.GENERIC_NAME,
                  e.target.value
                )
              }
              required
            />
            <label htmlFor="bonusquantity">Generic Name</label>
            {isFieldErrorVisible &&
              !newProductData?.[PRODUCT_DETAIL_FIELDS.GENERIC_NAME] && (
                <div class="invalidFeedback">
                  Please enter a valid Generic Name.
                </div>
              )}
          </div>

          <div className="formGroup formFloating fgrow1 maxWidth">
            <Select
              className="formSelect reactSelect"
              id="floatingSelect"
              value={{
                label: newProductData?.[PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY],
              }}
              options={medicalCategoryList}
              onChange={(option) =>
                handleProductDetailsUpdate(
                  PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY,
                  option?.value
                )
              }
              placeholder="Select Medical Category"
              styles={{
                control: (base) => ({
                  border: 0,
                  display: 'flex',
                  paddingTop: '20px',
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused
                    ? 'rgb(222, 235, 255)'
                    : state.isSelected
                      ? '#FFF'
                      : 'inherit',
                  color: '#212529',
                  '&:hover': {
                    backgroundColor: state.isSelected
                      ? '#DEEBFF'
                      : 'rgb(222, 235, 255)',
                  },
                }),
              }}
              getOptionLabel={(option) => option.label}
              isClearable
            />
            <label htmlFor="floatingSelect">Medical Category</label>
            {isFieldErrorVisible &&
              !newProductData?.[PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY] && (
                <div class="invalidFeedback">
                  Please choose Medical Category.
                </div>
              )}
          </div>
          <div className="formGroup formFloating fgrow1 maxWidth">
            <Select
              className="formSelect reactSelect"
              id="floatingSelect"
              value={newProductData?.[PRODUCT_DETAIL_FIELDS.SUPPLIER]}
              options={supplierList}
              onChange={(option) =>
                handleProductDetailsUpdate(
                  PRODUCT_DETAIL_FIELDS.SUPPLIER,
                  option
                )
              }
              placeholder="Supplier Name"
              styles={{
                control: (base) => ({
                  border: 0,
                  display: 'flex',
                  paddingTop: '20px',
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused
                    ? 'rgb(222, 235, 255)'
                    : state.isSelected
                      ? '#FFF'
                      : 'inherit',
                  color: '#212529',
                  '&:hover': {
                    backgroundColor: state.isSelected
                      ? '#DEEBFF'
                      : 'rgb(222, 235, 255)',
                  },
                }),
              }}
              getOptionLabel={(option) => option.name}
              isClearable
            />
            <label htmlFor="floatingSelect">Supplier Name</label>
            {isFieldErrorVisible &&
              !newProductData?.[PRODUCT_DETAIL_FIELDS.SUPPLIER] && (
                <div class="invalidFeedback">Please choose Supplier Name.</div>
              )}
          </div>

          <div className="formGroup mt-5">
            <div>
              <label class="formCheckLabel" htmlFor="Origin">
                Product Origin?
              </label>
            </div>
            <div className="formSection dFlex mb-5">
              <div class="formCheck">
                <input
                  class="formCheckInput"
                  type="radio"
                  name="flexRadioOrigin"
                  id="Origin"
                  checked={
                    newProductData?.[PRODUCT_DETAIL_FIELDS.ORIGIN] ===
                    PRODUCT_ORIGIN.FOREIGN
                  }
                  onChange={(e) =>
                    handleProductDetailsUpdate(
                      PRODUCT_DETAIL_FIELDS.ORIGIN,
                      PRODUCT_ORIGIN.FOREIGN
                    )
                  }
                />
                <label class="formCheckLabel" htmlFor="Origin">
                  Foreign
                </label>
              </div>
              <div class="formCheck">
                <input
                  class="formCheckInput"
                  type="radio"
                  name="flexRadioOrigin"
                  id="nOrigin"
                  checked={
                    newProductData?.[PRODUCT_DETAIL_FIELDS.ORIGIN] ===
                    PRODUCT_ORIGIN.LOCAL
                  }
                  onChange={(e) =>
                    handleProductDetailsUpdate(
                      PRODUCT_DETAIL_FIELDS.ORIGIN,
                      PRODUCT_ORIGIN.LOCAL
                    )
                  }
                />
                <label class="formCheckLabel" htmlFor="nOrigin">
                  Local
                </label>
              </div>
              {isFieldErrorVisible &&
                !newProductData?.[PRODUCT_DETAIL_FIELDS.ORIGIN] && (
                  <div class="invalidFeedback">
                    Please select Product Origin.
                  </div>
                )}
            </div>
          </div>
          <div className="formGroup">
            <div>
              <label class="formCheckLabel" htmlFor="Type">
                Product Type?
              </label>
            </div>
            {/* {PRODUCT_CATEGORY.PHARMACEUTICAL} */}
            <div className="formSection dFlex mb-5">
              <div class="formCheck">
                <input
                  class="formCheckInput"
                  type="radio"
                  name="flexRadioType"
                  id="Type"
                  checked={
                    newProductData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_CATEGORY] ===
                    PRODUCT_CATEGORY.PHARMACEUTICAL
                  }
                  onChange={(e) =>
                    handleProductDetailsUpdate(
                      PRODUCT_DETAIL_FIELDS.PRODUCT_CATEGORY,
                      PRODUCT_CATEGORY.PHARMACEUTICAL
                    )
                  }
                />
                <label class="formCheckLabel" htmlFor="Type">
                  Pharma
                </label>
              </div>
              <div class="formCheck">
                <input
                  class="formCheckInput"
                  type="radio"
                  name="flexRadioType"
                  id="nType"
                  checked={
                    newProductData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_CATEGORY] ===
                    PRODUCT_CATEGORY.NON_PHARMACEUTICAL
                  }
                  onChange={(e) =>
                    handleProductDetailsUpdate(
                      PRODUCT_DETAIL_FIELDS.PRODUCT_CATEGORY,
                      PRODUCT_CATEGORY.NON_PHARMACEUTICAL
                    )
                  }
                />
                <label class="formCheckLabel" htmlFor="nType">
                  Non Pharma
                </label>
              </div>
              {isFieldErrorVisible &&
                !newProductData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_CATEGORY] && (
                  <div class="invalidFeedback">
                    Please select a product type.
                  </div>
                )}
            </div>
          </div>
          <div className="formGroup mt-5">
            <div>
              <label class="formCheckLabel" htmlFor="Prescription">
                Prescription Required?
              </label>
            </div>
            <div className="formSection dFlex mb-5">
              <div class="formCheck">
                <input
                  class="formCheckInput"
                  type="radio"
                  name="flexRadioPrescription"
                  id="Prescription"
                  checked={
                    newProductData?.[
                      PRODUCT_DETAIL_FIELDS.PRESCRIPTION_REQUIRED
                    ] === 'YES'
                  }
                  onChange={(e) =>
                    handleProductDetailsUpdate(
                      PRODUCT_DETAIL_FIELDS.PRESCRIPTION_REQUIRED,
                      'YES'
                    )
                  }
                />
                <label class="formCheckLabel" htmlFor="Prescription">
                  YES
                </label>
              </div>
              <div class="formCheck">
                <input
                  class="formCheckInput"
                  type="radio"
                  name="flexRadioPrescription"
                  id="nPrescription"
                  checked={
                    newProductData?.[
                      PRODUCT_DETAIL_FIELDS.PRESCRIPTION_REQUIRED
                    ] === 'NO'
                  }
                  onChange={(e) =>
                    handleProductDetailsUpdate(
                      PRODUCT_DETAIL_FIELDS.PRESCRIPTION_REQUIRED,
                      'NO'
                    )
                  }
                />
                <label class="formCheckLabel" htmlFor="nPrescription">
                  NO
                </label>
              </div>
              {isFieldErrorVisible &&
                !newProductData?.[
                  PRODUCT_DETAIL_FIELDS.PRESCRIPTION_REQUIRED
                ] && (
                  <div class="invalidFeedback">Please select Prescription.</div>
                )}
            </div>
          </div>
          <>
            <div className="formGroup typeFile">
              <div className="beforeUpload">
                <div className="inputHeading">Product image (Optional)</div>
                {!newProductData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_IMAGE]
                  ?.name && (
                  <div className="customFile">
                    <input
                      type="file"
                      className="fileInput"
                      id="productImage"
                      aria-describedby="productImage"
                      onChange={(e) => {
                        e.preventDefault()
                        handleProductDetailsUpdate(
                          PRODUCT_DETAIL_FIELDS.PRODUCT_IMAGE,
                          e.target.files[0]
                        )
                      }}
                    />
                    <label className="fileLabel" htmlFor="productImage">
                      <AttachIcon />
                    </label>
                  </div>
                )}
              </div>
              {!!newProductData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_IMAGE]
                ?.name && (
                <>
                  <div className="uploadFile dFlex jcSpaceBetween">
                    <div className="">
                      <div className="uploadFileName">
                        {newProductData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_IMAGE]
                          ?.name || ''}
                      </div>
                      <div className="uploadFileProgress">
                        <div className="progress progress-moved">
                          <div className="animation progress-bar"></div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="cancelUpload"
                      onClick={(e) => {
                        handleProductDetailsUpdate(
                          PRODUCT_DETAIL_FIELDS.PRODUCT_IMAGE,
                          undefined
                        )
                      }}
                    >
                      <CloseIcon />
                      <div className="cancelUpload">
                        <CheckIcon />{' '}
                      </div>
                    </div>
                  </div>
                  {!newProductData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_IMAGE] && (
                    <div className="invalidFeedback">
                      Please choose a valid file
                    </div>
                  )}

                  {previewImageSrc && (
                    <>
                      <div
                        className="previewImageWrapper"
                        onClick={() => setOpenPreview(true)}
                        style={{ cursor: 'pointer' }}
                      >
                        <img
                          src={previewImageSrc}
                          alt="Preview"
                          className="previewImage"
                        />
                      </div>

                      {openPreview && (
                        <div
                          className="dialogOverlay"
                          onClick={() => setOpenPreview(false)}
                        >
                          <div
                            className="dialogContent"
                            onClick={(e) => e.stopPropagation()} // prevent close on inner click
                          >
                            <img
                              src={previewImageSrc}
                              alt="Large Preview"
                              className="dialogImage"
                            />

                            <div className="dialogButton">
                              <button
                                className="dialogCloseButton"
                                onClick={() => setOpenPreview(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
              {false &&
                isFieldErrorVisible &&
                !newProductData[PRODUCT_DETAIL_FIELDS.PRODUCT_IMAGE]?.name && (
                  <div className="invalidFeedback">Please upload an image.</div>
                )}
            </div>
          </>
          <div className="formGroup formFloating formInputText fgrow1">
            <div className="preInputGroup backColor">
              <div className="preInputText">BDT</div>
            </div>
            <input
              type="text"
              className="formControl"
              id="amount"
              placeholder="Rate/Unit"
              disabled={props.isViewOnlyProduct}
              value={
                newProductData?.[PRODUCT_DETAIL_FIELDS.RATE_PER_UNIT] || ''
              }
              onChange={(e) =>
                handleProductDetailsUpdate(
                  PRODUCT_DETAIL_FIELDS.RATE_PER_UNIT,
                  e.target.value
                )
              }
              required
            />
            <label htmlFor="amount">Rate/Unit</label>
            {false &&
              isFieldErrorVisible &&
              !newProductData?.[PRODUCT_DETAIL_FIELDS.RATE_PER_UNIT] && (
                <div class="invalidFeedback">Please enter a valid Rate.</div>
              )}
          </div>
        </div>
      </SideDrawer>
    </>
  )
}

export default ManageProductForm
